import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { EcranErreurConfiguration } from './components/config/ecran-erreur-configuration';
import { chargerConfiguration } from './lib/api/config';
import { queryClient } from './lib/query-client';
import { routeTree } from './routeTree.gen';
import './styles.css';

// ── Sentry (optional) ────────────────────────────────────────────────────────
// Uncomment to enable error reporting. Requires VITE_SENTRY_DSN at build time.
//
// import * as Sentry from '@sentry/react';
// if (import.meta.env.VITE_SENTRY_DSN) {
//   Sentry.init({
//     dsn: import.meta.env.VITE_SENTRY_DSN,
//     environment: import.meta.env.MODE,
//     tracesSampleRate: 0.1,
//   });
// }

// The scroll restoration of the router (B8, #13): "retour" puts the page, and the zone of the
// cards of the history (`data-scroll-restoration-id`), back where they were; a new navigation
// starts at the top.
const router = createRouter({ routeTree, scrollRestoration: true });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found.');

// The public configuration (Tahiti URLs and identifiers) is checked before anything
// else: an absent or invalid variable shows a readable error page instead of an
// application that would fail on its first call. The router, and with it the session
// guard, is only mounted when the configuration is valid.
const configuration = chargerConfiguration();

createRoot(rootEl).render(
  <StrictMode>
    {configuration.ok ? (
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    ) : (
      <EcranErreurConfiguration problemes={configuration.problemes} />
    )}
  </StrictMode>,
);
